import { useEffect } from 'react'

import { isNotNullish } from '@local/utils'

import { TimelineTab, UpcomingBookingQueryQuery, UpcomingOrderQueryQuery } from '@web/federation/gql/graphql'
import { convertMapUpcomingToMarker } from '@web/pages/timeline/components/TimelineUpcoming/unit'
import { MAX_UPCOMING_MARKER } from '@web/pages/timeline/constant'
import { useTimelineContext } from '@web/pages/timeline/index.context'
import {
  BookingCardItemType,
  MapUpcomingItemType,
  OrderCardItemType,
} from '@web/ui/pages/home/components/Sections/UIUpComingSection'

export const useUpcomingMarkers = ({
  loading,
  firstDisplay,
  upcomingBookingItems,
  upcomingOrderItems,
  firstDisplayCount,
  upcomingBookingData,
  upcomingOrderData,
}: {
  loading: boolean
  firstDisplay: boolean
  firstDisplayCount: number
  upcomingBookingItems: BookingCardItemType[]
  upcomingOrderItems: OrderCardItemType[]
  upcomingBookingData: UpcomingBookingQueryQuery | undefined
  upcomingOrderData: UpcomingOrderQueryQuery | undefined
}) => {
  const { tab, setUpcomingMarkers, setUpcomingLoading } = useTimelineContext()

  useEffect(() => {
    if (!loading) setUpcomingLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const upcomingItems: MapUpcomingItemType[] = (() => {
    if (tab === TimelineTab.Order)
      return firstDisplay ? upcomingOrderItems.slice(0, firstDisplayCount) : upcomingOrderItems

    if (tab === TimelineTab.Reservation)
      return firstDisplay ? upcomingBookingItems.slice(0, firstDisplayCount) : upcomingBookingItems

    if (tab === TimelineTab.TrainTicket) return []

    // 정렬 스펙 : 주문 > 예약 순
    // 클라는 타입 순 정렬만 지원, 타입 내 정렬은 BFF에서 담당.
    // https://wiki.navercorp.com/pages/viewpage.action?pageId=2550239294#:~:text=%EA%B3%B5%ED%86%B5-,%EC%97%85%EC%BB%A4%EB%B0%8D%20%EC%B9%B4%EB%93%9C%20%EC%A0%95%EB%A0%AC%20%EC%88%9C%EC%84%9C,-%EC%B5%9C%EB%8C%80%2010%EA%B0%9C
    return [...upcomingOrderItems, ...upcomingBookingItems]
  })()

  useEffect(() => {
    const upcomingMarkers = upcomingItems.map(convertMapUpcomingToMarker).filter(isNotNullish)
    setUpcomingMarkers(upcomingMarkers.slice(0, MAX_UPCOMING_MARKER))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upcomingBookingData, upcomingOrderData])
}
